import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-pop-up',
  templateUrl: './success-pop-up.component.html',
  styleUrls: ['./success-pop-up.component.scss']
})
export class SuccessPopUpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
